// Инстанс локальной БД PowerSync — лист графа импортов.
//
// Вынесен из `client.ts` намеренно: восстановление после сбоя синка
// (`upload-failures.ts`, `sync-recovery.ts`) читает локальную SQLite, а
// `client.ts` тянет `connector.ts`, который тянет журнал отказов. Пока доступ к
// БД жил в `client.ts`, кольцо client → connector → upload-failures замыкалось
// динамическим `await import("./client.js")` — рантайм это переживал (импорт
// ленивый), а `pnpm lint:cycles:web` был красным на каждом коммите.
//
// Конкретную реализацию БД даёт `@powersync-impl` — Vite-алиас на web-версию
// (WASM SQLite + IndexedDB VFS) либо на нативную (@powersync/capacitor) в
// сборках mobile-app / mobile-dev.
import type { CommonPowerSyncDatabase } from "@powersync/common";
import { createPowerSyncDatabase } from "@powersync-impl";
import { AppSchema } from "./schema.js";

const DB_FILENAME = "studyhub.db";

let _db: CommonPowerSyncDatabase | null = null;

export function getPowerSync(): CommonPowerSyncDatabase {
	if (!_db) {
		_db = createPowerSyncDatabase(AppSchema, DB_FILENAME);
		exposeE2EBridge(_db);
	}
	return _db;
}

/**
 * Инстанс, если он уже создан, иначе `null`.
 *
 * Нужен там, где создавать БД ради ответа бессмысленно (индикатор очереди на
 * холодном старте): `getPowerSync()` открыл бы SQLite только чтобы вернуть 0.
 */
export function peekPowerSync(): CommonPowerSyncDatabase | null {
	return _db;
}

/**
 * Мост для Playwright: offline-сценарии работают с локальной SQLite и очередью
 * напрямую, а не через вёрстку — иначе тест ломается от любого рефакторинга UI.
 * Только dev-сборка (E2E поднимает `vite dev`), в прод-бандл не попадает.
 */
function exposeE2EBridge(db: CommonPowerSyncDatabase): void {
	if (!import.meta.env.DEV || typeof window === "undefined") return;
	(window as unknown as { __STUDYHUB_E2E__?: unknown }).__STUDYHUB_E2E__ = {
		db,
		hasSynced: () => db.currentStatus?.hasSynced === true,
		pendingUploads: async () => (await db.getCrudBatch())?.crud.length ?? 0,
	};
}
